<template>
    <div>
        <Carregamento v-if="!live"/>
        <div v-else>
            <section id="containerLive">
                <div class="container py-5">
                    <Caroussel class="mb-4"/>
                    <div class="row">
                        <div :class="{'col-md-8 col-lg-8':live.live.chat[`${lang}`], 'col':!live.live.chat[`${lang}`]}">
                            <Video/>
                        </div>

                        <!-- <div class="col-3">
                            <p class="text-white" style="font-size: 20px; margin-bottom: 5px;">
                                DÚVIDAS?
                            </p>

                            <p class="text-white" style="font-size: 16px;">
                                Envie sua pergunta através<br>
                                do formulário abaixo:
                            </p>

                            <a href="https://form.jotform.com/260494775361061" target="_blank" class="btn myBtn">
                                Enviar pergunta
                            </a>
                        </div> -->

                        <div class="w-100 d-md-none my-2" v-if="live.live.chat[`${lang}`]"></div>
                        <div class="col" v-if="live.live.chat[`${lang}`]">
                            <Chat/>
                        </div>
                    </div>
                    <!-- <Download /> -->
                </div>
            </section>
            <div class="live">
                <Footer :lang="lang"/>
            </div>
        </div>
    </div>
</template>



<script>
    import { mapState } from 'vuex';
    import {api} from '@/services.js'
    // import Logo from '@/components/Login/Logo.vue'
    import Video from '@/components/Live/Video.vue'
    import Footer from '@/components/Live/Footer.vue'
    // import Download from '@/components/Live/Download.vue'
    import Caroussel from '@/components/Live/Carousel.vue'
    import Chat from '@/components/Live/Chat.vue'

    export default {
        props: ['id','lang'],
        name: "Live",
        components: {
            // Logo,
            Chat,
            Caroussel,
            Video,
            // Download,
            Footer
        },
         data() {
            return {
                btnStyles: {},
                state: null
            }
        },
        computed: {
            ...mapState(["live", "login"])
        },
        methods: {
            getLive() {
                this.$store
                    .dispatch('getLive')
                    .then(() => {
                        if(this.live.waiting[`${this.lang}`]=='true' || this.live.waiting[`${this.lang}`]) {
                            this.$router.push(`/waiting/${this.lang}`)
                        }
                         if(this.live.login.config.state == 'public') {
                            this.state = "public"
                        }
                        this.setStyle();
                        this.checkToken()
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            setStyle() {
                let obj = this.$store.state.live;
                let prefix = obj.live.body;

                document.body.style.cssText =
                    `background: url(${prefix.styles.backgroundImage}) ${prefix.styles.backgroundColor};`;

                this.btnStyles = prefix.button;

            },
            logOut(){
                window.localStorage.removeItem("token");
                this.$store.commit("UPDATE_LOGIN", false);
                this.$router.push(`/${this.lang}/`);
            },
            checkToken(){
                if(this.live.login.config.state == "public"){
                    null
                } else if(this.live.login.config.state == "private" && this.$route.params.lang != "en") {
                //    !window.localStorage.getItem("token") ? this.$router.push(`/login/${this.lang}`) : null
                    if(window.localStorage.getItem("mail")) {
                        var item = {
                            liveId: this.live.id,
                            lang: this.lang,
                            email: window.localStorage.getItem("mail"),
                            originBy: 'Live',
                            // Essa chamada serve apenas para validar o acesso do usuario a esse idioma.
                            // O backend nao deve gravar registro de login quando esse flag vier true,
                            // senao cada carregamento da live duplica os dados no banco.
                            validateOnly: true
                        }

                        api.login(item).then(res => {
                            if(res.data.code!=1) {
                                this.$gtag.event('User not able to this live lang', { method: 'Google' })
                                this.$router.push(`/login/${this.lang}`)
                            }
                        })
                    }else {
                        this.$router.push(`/login/${this.lang}`)
                    }
                }
            },
            setLang(){
                this.$route.params.lang ? this.$store.commit('UPDATE_LANG', this.$route.params.lang) : this.$store.commit('UPDATE_LANG', 'pt')
                if(this.$route.params.lang!='pt') {
                    this.$router.push(`/login/pt`)
                }
            }
        },
        created() {
            this.setLang()
            this.getLive()
        }
    }
</script>

<style scoped>
.myBtn{
    border: none;
    border-radius: 10px;
    color: #fff;
    background: #569992;
    font-family: 'museo-sans-900';
    text-transform: uppercase;
    padding: 10px 15px;
}
#containerLive {
    min-height: calc(100vh - 74px);
}
.live {
  
}
.live .header {
  background: #5ea69b;
  height: 200px;
}
@media (max-width: 991px) {
  .live .header {
    height: 180px;
  }
}
.live .header .bg {
  background-size: cover;
  background-position: center center;
}
    /* .my-card {
        margin: 0;
        padding: 15px;
        border-radius: 0;
        border: none;
    } */
</style>